import React, { Component } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
//import HothNav from '../nav/HothNav';
import "./Main.css";
// News
//import Beacon from "../beacons/beacon/Beacon";

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      splashComplete: false,
    };
  }

  componentDidMount() {
    //this.props.navigateTo("/gardens/2020/cross-country-grid");
    //const route = "/gardens/2020/cross-country-grid";
    const route = "/portfolio";
    console.log("Main - componentDidMount - set route to ", route);
    const path = route;
    console.log("Main props: ", this.props);
    //this.props.router.go(path)
    browserHistory.push(path);
  }

  render() {
    const mainStyle =
      this.props.location.pathname === "/"
        ? { display: "block", margin: 0, padding: 0 }
        : { top: 25, left: 25 };
    return (
      <div>
        {/*
        <Beacon  />
        <HothNav /> */}
        <div style={mainStyle}>
          <div className="gap" />
          {this.props.children}
          <div style={{ pointerEvents: "none" }} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  app: state.app,
  location: ownProps.location,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/components/main/Main.js